"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "fakeRegions", {
  enumerable: true,
  get: function () {
    return _subgroups.fakeRegions;
  }
});
Object.defineProperty(exports, "fakeSites", {
  enumerable: true,
  get: function () {
    return _subgroups.fakeSites;
  }
});
Object.defineProperty(exports, "fakeTeams", {
  enumerable: true,
  get: function () {
    return _subgroups.fakeTeams;
  }
});
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select2 = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../hooks");
var _services = require("../../../services");
var _icons = require("../../icons");
var _individual = _interopRequireDefault(require("./individual"));
var _statCard = _interopRequireDefault(require("./stat-card"));
var _subgroups = _interopRequireWildcard(require("./subgroups"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const displayTypesMap = {
  individual: {
    labelKey: 'commons.challenges.leaderboard.by_cyclists'
  },
  companySite: {
    labelKey: 'commons.challenges.leaderboard.by_sites'
  },
  companyTeam: {
    labelKey: 'commons.challenges.leaderboard.by_teams'
  },
  companyRegion: {
    labelKey: 'commons.challenges.leaderboard.by_regions'
  },
  companySubsidiary: {
    labelKey: 'commons.challenges.leaderboard.by_subsidiaries'
  }
};
function CompanyLeaderboard({
  Button: _Button,
  FakeItemsCard,
  partner,
  isFree,
  currentUser,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  freeOfferSubgroupsLeaderboardsMaxRowsCount,
  challenge,
  displayTypes,
  employee
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [displayType, setDisplayType] = (0, _react.useState)('individual');
  const [page, setPage] = (0, _react.useState)(1);
  const [individualLeaderboard, setIndividualLeaderboard] = (0, _react.useState)();
  const [userChallenge, setUserChallenge] = (0, _react.useState)();
  const [subgroupsLeaderboard, setSubgroupsLeaderboard] = (0, _react.useState)();
  const [count, setCount] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const [downloading, setDownloading] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  const {
    formatNumber
  } = (0, _hooks.useUnits)();
  const {
    downloadXLSX
  } = (0, _hooks.useFileSaver)();
  (0, _react.useEffect)(() => {
    if (initialized && challenge) {
      if (page > 1) setPage(1);
      getLeaderboard(challenge, 1);
    }
    setInitialized(true);
    return () => {
      cancelPromises();
    };
  }, [initialized, challenge, displayType]);
  (0, _react.useEffect)(() => {
    if (challenge && page > 1) getLeaderboard(challenge, page);
  }, [page]);
  async function getLeaderboard(challenge, page) {
    if (page === 1) {
      setIndividualLeaderboard(undefined);
      setUserChallenge(undefined);
      setSubgroupsLeaderboard(undefined);
      setCount(undefined);
    }
    setLoading(true);
    try {
      if (displayType === 'individual') {
        const [{
          count,
          leaderboard: pageLeaderboard
        }, {
          leaderboard: [userItem]
        }] = await cancellablePromise(Promise.all([_services.GeogroupService.getChallengeLeaderboard(challenge.id, {
          page,
          pageSize: isFree ? freeOfferEmployeesLeaderboardsMaxRowsCount : 50
        }), currentUser && page === 1 ? _services.GeogroupService.getChallengeLeaderboard(challenge.id, {
          page: 1,
          pageSize: 1,
          userId: currentUser.id
        }) : {
          leaderboard: []
        }]));
        setCount(count);
        if (page === 1) setIndividualLeaderboard(pageLeaderboard);else setIndividualLeaderboard([...(individualLeaderboard || []), ...pageLeaderboard]);
        if (userItem?.leaderboardIndex !== undefined) setUserChallenge({
          rank: userItem.leaderboardIndex,
          progressValue: userItem.progressValue
        });else setUserChallenge(null);
      } else if (partner) {
        const leaderboard = await cancellablePromise(_services.GeogroupService.getChallengeLeaderboardBySubGroups(partner, challenge.id, {
          subGroupDisplay: displayType
        }));
        setCount(leaderboard.length);
        setSubgroupsLeaderboard(isFree ? leaderboard.slice(0, freeOfferSubgroupsLeaderboardsMaxRowsCount) : leaderboard);
      }
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
    setLoading(false);
  }
  function handleXLSXDownload() {
    if (!partner || !challenge) return;
    setDownloading(true);
    if (displayType === 'individual') {
      if (employee && individualLeaderboard) {
        downloadXLSX(`Challenge_${[challenge.title, partner.title].join('_').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '_')}_${(0, _moment.default)().format('YYYY-MM-DD')}.xlsx`, ['Classement', 'Pseudo', 'Nom', 'Prénom', ...(employee.role === 'employee' ? [] : ['Adresse email']), 'Équipe', 'Site', 'Score (pts)'], individualLeaderboard.map(({
          rank,
          username,
          firstName,
          lastName,
          professionalEmail,
          progressValue,
          subGroups
        }) => {
          const site = subGroups?.find(({
            type
          }) => type === 'companySite')?.title;
          const team = subGroups?.find(({
            type
          }) => type === 'companyTeam')?.title;
          return [rank, username || t('commons.news.deleted_user'), lastName || '-', firstName || '-', ...(employee.role === 'employee' ? [] : [professionalEmail || '-']), site || '-', team || '-', challenge.type === 'traveledDistance' ? (progressValue / 1000).toFixed(1) : progressValue];
        }));
      }
    } else if (subgroupsLeaderboard) {
      downloadXLSX(`Challenge_${[challenge.title, partner.title].join('_').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '_')}_${(0, _moment.default)().format('YYYY-MM-DD')}.xlsx`, ['Classement', 'Nom', 'Score (pts)'], subgroupsLeaderboard.map(({
        rank,
        username,
        progressValue
      }) => [rank, username || t('commons.news.deleted_user'), challenge.type === 'traveledDistance' ? (progressValue / 1000).toFixed(1) : progressValue]));
    }
    setDownloading(false);
  }
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    padding: 3,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    width: {
      '@': '100%',
      '@500': 'calc((100% - 16px) / 2)',
      '@800': 'calc((100% - 32px) / 4)'
    }
  }, /*#__PURE__*/_react.default.createElement(_statCard.default, {
    bgColor: "#e4f2de",
    caption: t('commons.challenges.impact_points'),
    Icon: _icons.GlobeIcon,
    iconColor: "#268b1d",
    value: challenge ? formatNumber(Math.round(challenge.overralProgressValue)) : challenge === null ? 0 : undefined
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    width: {
      '@': '100%',
      '@500': 'calc((100% - 16px) / 2)',
      '@800': 'calc((100% - 32px) / 4)'
    }
  }, /*#__PURE__*/_react.default.createElement(_statCard.default, {
    bgColor: "#e7f4fA",
    caption: t('commons.challenges.label_participants', {
      count: challenge ? challenge.nbMembers : 2
    }),
    Icon: _icons.PeopleIcon,
    iconColor: "#1589BB",
    value: challenge ? formatNumber(Math.round(challenge.nbMembers)) : challenge === null ? 0 : undefined
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "h6"
  }, t('commons.challenges.navigation.leaderboard'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    margin: "none",
    sx: {
      width: 200
    }
  }, /*#__PURE__*/_react.default.createElement(_Select2.default, {
    onChange: ({
      target: {
        value
      }
    }) => setDisplayType(value),
    size: "small",
    value: displayType
  }, displayTypes.map(key => /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    key: key,
    value: key
  }, t(displayTypesMap[key].labelKey))))), (displayType === 'individual' ? !individualLeaderboard || individualLeaderboard.length > 0 : !subgroupsLeaderboard || subgroupsLeaderboard.length > 0) ? /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: downloading || !challenge || (displayType === 'individual' ? !individualLeaderboard : !subgroupsLeaderboard),
    onClick: handleXLSXDownload,
    size: "medium",
    startIcon: downloading ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_icons.ExportIcon, null),
    variant: "text"
  }, t('commons.actions.export')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), displayType === 'individual' ? /*#__PURE__*/_react.default.createElement(_individual.default, {
    Button: _Button,
    count: count,
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferEmployeesLeaderboardsMaxRowsCount,
    isFree: isFree,
    leaderboard: individualLeaderboard,
    loading: loading,
    page: page,
    setPage: setPage,
    userChallenge: userChallenge
  }) : /*#__PURE__*/_react.default.createElement(_subgroups.default, {
    count: count,
    displayType: displayType,
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferSubgroupsLeaderboardsMaxRowsCount: freeOfferSubgroupsLeaderboardsMaxRowsCount,
    isFree: isFree,
    leaderboard: subgroupsLeaderboard
  })));
}
var _default = exports.default = CompanyLeaderboard;